import { useContext, useState } from 'react'
import { useSignMessage } from 'wagmi'
import { isPenguinPadAdmin } from '@/lib/colonyOfficial'
import { deleteProjectPost } from '@/lib/projectPosts'
import { WalletAddressContext } from '@/lib/walletContext'
import { deleteWalletPost } from '@/lib/walletPosts'

export default function AdminDeletePostButton({
  postKind,
  postId,
}: {
  postKind: 'wallet' | 'project'
  postId: string
}) {
  const wallet = useContext(WalletAddressContext)
  const { signMessageAsync } = useSignMessage()
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  if (!isPenguinPadAdmin(wallet) || !postId)
    return null

  async function handleClick() {
    if (typeof window !== 'undefined' && !window.confirm('Delete this post? This cannot be undone.'))
      return
    if (!wallet)
      return
    setBusy(true)
    setError('')
    try {
      const signMessage = (message: string) => signMessageAsync({ message })
      if (postKind === 'wallet')
        await deleteWalletPost({ postId, wallet, signMessage })
      else
        await deleteProjectPost({ postId, wallet, signMessage })
    }
    catch (err) {
      setError(err instanceof Error ? err.message : 'Could not delete this post')
    }
    finally {
      setBusy(false)
    }
  }

  return (
    <div className="shrink-0 text-right">
      <button
        type="button"
        onClick={handleClick}
        disabled={busy}
        className="rounded-full border border-red-400/40 px-2.5 py-1 text-[10px] font-semibold text-red-400 hover:bg-red-400/10 disabled:opacity-50"
      >
        {busy ? 'Deleting…' : 'Admin delete'}
      </button>
      {error ? <p className="mt-1 max-w-[10rem] text-[10px] text-red-400">{error}</p> : null}
    </div>
  )
}
